import { createContext } from 'react';

const CatalogContext = createContext(void 0);

CatalogContext.displayName = 'context(catalog)';

export default CatalogContext;